<div class="location-hierarchy">
	<ada-combo
		label="Search by"
		[options]="searchOptions"
		[value]="searchByIp()"
		(userChange)="onSearchOptionChange($event)"
	/>
	<ada-object-explorer
		[checkboxesEnabled]="true"
		[classNames]="objectClassName"
		[height]="'100%'"
		[id]="id"
		[isMultiSelect]="true"
		(nodeClicked)="nodeClicked($event)"
	/>
</div>
